// Exports
export default {
	"Button2_size_square-s": "Button2_size_square-s",
	"Button2-Icon": "Button2-Icon",
	"Icon_type_arrow": "Icon_type_arrow",
	"Button2-Icon_side_left": "Button2-Icon_side_left",
	"Button2-Text": "Button2-Text",
	"Button2-Icon_side_right": "Button2-Icon_side_right"
};
